module.exports = __webpack_public_path__ + "img/73_02.6a275f04.png";